module.exports = __webpack_public_path__ + "assets/b33.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b33.png
// module id = 620
// module chunks = 0